import { render, staticRenderFns } from "./pessoa_unidade.vue?vue&type=template&id=6a74278c&scoped=true&"
import script from "./pessoa_unidade.vue?vue&type=script&lang=js&"
export * from "./pessoa_unidade.vue?vue&type=script&lang=js&"
import style0 from "./pessoa_unidade.vue?vue&type=style&index=0&id=6a74278c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74278c",
  null
  
)

export default component.exports